import React, { useState, useId } from 'react';
import styles from "./ConfirmationPopup.module.css";
import CustomTextarea from 'Common/CustomTextArea';
import Validator, { ValidationTypes as V_Type } from 'react-form-supervalidator';
import ReactPortal from 'Components/ReactPortal/ReactPortal';
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew';
const ConfirmationPopup = ({ heading, subHeading, reasonBox, onConfirm, required, onCancel, buttonTitle, cancelButtonTitle, renderSubHeadingAsPre }) => {
    const [reason, setReason] = useState("");
    const [validationModel, setValidationModel] = useState({
        reasonError: null,
    });

    const uniqueId = useId(); // Using useId to generate a unique ID

    const handleChange = (e) => {
        const newValue = e.target.value.trimStart();
        setReason(newValue);
    };

    const setValidation = () => {
        let myValidationObj = {
            ...validationModel,
            reasonError: Validator(
                reason,
                [V_Type.required],
                ['Reason is required']
            ),
        };
        setValidationModel(myValidationObj);
        return Validator(myValidationObj, V_Type.NullCheck);
    };

    const handleSave = () => {
        if (required) {
            let myValidation = setValidation();
            if (myValidation) {
                return
            } else {
                onConfirm(reason);
            }
        } else {
            onConfirm(reason);
        }
    };

    return (
        <ReactPortal wrapperId={`confirmationPopup-${uniqueId}`}>
            <div className={styles.darkBG}>
                <div className={styles.centered}>
                    <div className={styles.modal}>
                        <div className="flex items-center justify-between">
                            <h5 className="text-[#2c3e50] text-[18px] font-semibold text-center w-full">
                                {heading || "Confirmation"}
                            </h5>
                            <button
                                onClick={() => onCancel(false)}
                                className="p-1.5 shrink-0 rounded border border-slate-200 hover:border-slate-300 shadow-sm ml-2"
                            >
                                <img src="/img/crossblack.svg" alt="cross" />
                            </button>
                        </div>
                        <div className={styles.modalContent}>
                            {subHeading ? (
                                renderSubHeadingAsPre ? (
                                    <pre className={styles.subHeading} style={{ fontFamily: 'inherit' }} dangerouslySetInnerHTML={{ __html: subHeading }} />
                                ) : (
                                    <p className={styles.subHeading}>{subHeading}</p>
                                )
                            ) : (
                                <p>Are you sure you want to delete?</p>
                            )}
                            {reasonBox && <>
                                <CustomTextarea value={reason} onChange={handleChange} rows="5" extraClass={`${styles.modeltextare} outline-none mt-1`} />
                                <span className='text-left'>
                                {validationModel.reasonError}
                                </span>
                            </>}
                        </div>
                        <div className={styles.modalActions}>
                            <div className={styles.actionsContainer}>
                                {onCancel && <CustomButtonNew label={cancelButtonTitle || 'Cancel'} variant={"outline"} onClick={() => onCancel(true)} />}
                                <CustomButtonNew label={buttonTitle || "Delete"} onClick={handleSave} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ReactPortal>
    );
};

export default ConfirmationPopup;
